import { useEffect, useState } from 'react'
import { Flex, Form, FormInstance, Select } from 'antd'
import { FormattedMessage } from 'react-intl'
import { lang } from './lang'
import VoiceSelect from './VoiceSelect'
import { formKeys } from '@/pages/Donation/components/DonationForm/constants'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'
import Label from '@/shared/components/Label'
import { FormValues } from '@/pages/Donation/types'

type Props = {
  form: FormInstance<FormValues>
}

export default function Voice({ form }: Props) {
  const { config } = useStreamerConfigContext()
  const voices = config?.text_donation_config?.tts_voices || []
  const defaultVoice = voices[0]?.voices[0] ?? null
  const [isSelectOpen, setSelectOpen] = useState(false)
  const voice = Form.useWatch<FormValues[typeof formKeys.voice]>(formKeys.voice, form)

  useEffect(() => {
    if (!voice) {
      form.setFieldValue(formKeys.voice, defaultVoice)
    }

    return () => form.setFieldValue(formKeys.voice, null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultVoice])

  return (
    <>
      <VoiceSelect
        isOpen={isSelectOpen}
        onClose={() => setSelectOpen(false)}
        options={voices}
        selectedVoice={voice}
        onSelectVoice={value => form.setFieldValue(formKeys.voice, value)}
      />
      <Flex vertical gap={4}>
        <Label>
          <FormattedMessage {...lang.voiceTitle} />
        </Label>
        <Form.Item name={formKeys.voice} noStyle>
          <Select
            labelRender={() => voice?.nickname ?? null}
            onClick={() => setSelectOpen(true)}
            open={false}
            size="large"
            placeholder={<FormattedMessage {...lang.voicePlaceholder} />}
          />
        </Form.Item>
      </Flex>
    </>
  )
}
